import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { createReducer, on } from '@ngrx/store'
import { loadNavigation } from './navigation.actions'

export interface INavigation {
  id: number
}
export const navigationFeatureName = 'navigation'

export interface INavigationState extends EntityState<INavigation> {}

export const navigationAdapter: EntityAdapter<INavigation> = createEntityAdapter<INavigation>({
  selectId: (navigation: INavigation) => navigation.id,
})

export const initialState: INavigationState = navigationAdapter.getInitialState()

export const navigationReducer = createReducer(
  initialState,

  on(loadNavigation, (state, { navigation }) => {
    return navigationAdapter.setAll(navigation, state)
  })
)
